



















































































































































































































































































































































import DocTemplateGenerateV2 from "@/components/doc-tempates/DocTemplateGenerateV2.vue";

interface IFirsFRDOParams {
  type: 0 | 1;
  number?: string;
  documentTypeIds?: Array<string>;
  categoryIds?: Array<string>;
  companyId?: string;
  ownerId?: string;
  protocolsIds?: Array<string>;
  coursesIds?: Array<string>;
  listenersIds?: Array<string>;
  status?: 1 | 0;
  documentOfRetraining?: string;
  internship?: string;
  graduateWork?: string;
  numberDocumentOfRetraining?: string;
  registerNumberDocumentOfRetraining?: string;
  issuedAtMin?: Date;
  issuedAtMax?: Date;
  expirationMin?: Date;
  expirationMax?: Date;
  expirationNullable?: boolean;
  isSignedAt?: boolean;
  signedAtMin?: Date;
  signedAtMax?: Date;
  createdAtMin?: Date;
  createdAtMax?: Date;
  updatedAtMin?: Date;
  updatedAtMax?: Date;
  isArchive?: boolean;
  archivedAtMin?: Date;
  archivedAtMax?: Date;
  isFisFrdoExported?: boolean;
  fisFrdoExportedAtMin?: Date;
  fisFrdoExportedAtMax?: Date;
  fisFrdoType?: "professional.education" | "additional.professional.education";
  offset?: number;
  limit?: number;
  sort?:
    | "createdAt"
    | "updatedAt"
    | "signedAt"
    | "issuedAt"
    | "expiration"
    | "number"
    | "originalSeries"
    | "registerNumber";
  order?: "ASC" | "DESC";
  options?: any;
}

import { Vue, Component, Watch } from "vue-property-decorator";
import { FinalDocumentParams } from "@/getinfo-api/final-document.ts";
import { FinalDocument as IFinalDocument } from "@/api/models/final-document";
import FinalDocumentForm from "@/components/final-document/FinalDocumentForm.vue";
import FinalDocumentListItem from "@/components/final-document/FinalDocumentListItem.vue";
import { getCurrentCompanyId, isRoot } from "@/plugins/roles";
import SelectEntity from "@/components/form/SelectEntity.vue";
import api from "@/getinfo-api";
import { EducationProtocol as IEducationProtocol } from "@/api/models";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import { FileItem as IFileItem } from "@/api/models/file-item";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import CustomButton from "@/components/form/CustomButton.vue";
import CustomTable from "@/components/form/CustomTable.vue";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CField from "@/components/form/CField.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { EducationProtocolListClass } from "@/classes/list/EducationProtocolListClass";
import { ResourceCategory as IResourceCategory } from "@/api/models/resource-category";
import { TermList as ITermList } from "@/api/models/term-list";
import { Term as ITerm } from "@/api/models/term";
@Component({
  components: {
    DocTemplateGenerateV2,
    CSingleSelect,
    CField,
    CPage,
    CustomTable,
    CustomButton,
    CustomDatepicker,
    FinalDocumentForm,
    FinalDocumentListItem,
    SelectEntity
  }
})
export default class FinalDocumentList extends Vue {
  issuedAtMin!: Date | undefined;
  issuedAtMax!: Date | undefined;
  isGettingResult: boolean = false;
  resourceType!: string;
  resourceId!: string;
  listenerId!: string | undefined;
  categoryId!: string | undefined;
  protocol!: IEducationProtocol | undefined;
  list: boolean = true;
  reset: boolean = true;
  file!: IFileItem;
  type!: number;
  sortedBy: any = "registerNumber";
  order?: "ASC" | "DESC" = "DESC";
  isSigned: boolean | undefined;
  showSpinner: boolean = false;
  isSpinnerLookAtHe: boolean = false;
  categoryList!: IResourceCategory;
  number!: string;
  protocols: EducationProtocolListClass = new EducationProtocolListClass({
    order: "DESC"
  });
  docTypeId!: string | undefined;
  docTypeList: Array<ITerm> = [];
  fisFRDOStep: string = "500";
  isShowFisFRDOSettings: boolean = false;
  registerNumber!: string;
  checkedFinalDocument: Array<string> = [];
  checkAllDocuments!: boolean;
  modalShow: boolean = false;
  buttonType: string = "passive";
  isFisFrdoExported?: boolean | undefined;
  fisFrdoExportedAtMin?: Date | undefined;
  fisFrdoExportedAtMax?: Date | undefined;
  fisFrdoType?:
    | "professional.education"
    | "additional.professional.education"
    | undefined;

  data() {
    return {
      registerNumber: undefined,
      checkAllDocuments: undefined,
      blankNumber: undefined,
      resisterNumber: undefined,
      docTypeId: undefined,
      categoryId: undefined,
      categoryList: undefined,
      number: undefined,
      isSigned: undefined,
      file: undefined,
      type: undefined,
      issuedAtMin: undefined,
      issuedAtMax: undefined,
      protocol: undefined,
      resourceType: undefined,
      resourceId: undefined,
      listenerId: undefined,
      documentIdToDelete: undefined,
      isFisFrdoExported: undefined,
      fisFrdoExportedAtMin: undefined,
      fisFrdoExportedAtMax: undefined,
      fisFrdoType: undefined
    };
  }

  generateFileName() {
    const timestamp = new Date();
    const formattedDate = this.moment(timestamp).format("LLL");
    return `Итоговые документы от ${formattedDate}`;
  }

  showChildData(data: string) {
    this.checkedFinalDocument.push(data);
  }

  deleteExistId(data: string) {
    this.checkedFinalDocument = this.checkedFinalDocument.filter(
      item => item !== data
    );
  }

  @Watch("selectedCompany")
  updateCompany() {
    this.clearForm();
  }

  @Watch("checkAllDocuments")
  clearSelectedItems() {
    if (!this.checkAllDocuments) {
      this.checkedFinalDocument = [];
    }
  }

  get uniqueItems() {
    return [...new Set(this.checkedFinalDocument)];
  }

  get screenWidth() {
    return window.innerWidth;
  }

  getProtocol(item: IEducationProtocol) {
    this.protocol = item;
    if (this.protocol.listeners?.length) {
      this.listenerId = undefined;
    }
  }

  get root() {
    return isRoot();
  }

  get selectedCompany() {
    return getCurrentCompanyId();
  }

  get count() {
    return this.$store.getters["finalDocuments/GET_COUNT"];
  }

  get finalDocuments(): Array<IFinalDocument> {
    return this.$store.getters["finalDocuments/GET_LIST"];
  }

  clearForm() {
    this.registerNumber = "";
    this.number = "";
    this.protocol = undefined;
    this.listenerId = undefined;
    this.issuedAtMax = undefined;
    this.issuedAtMin = undefined;
    this.isSigned = undefined;
    this.reset = false;
    this.$store.commit("finalDocuments/CLEAR");
    this.isFisFrdoExported = undefined;
    this.fisFrdoType = undefined;
    this.fisFrdoExportedAtMin = undefined;
    this.fisFrdoExportedAtMax = undefined;
    this.$nextTick(() => (this.reset = true));
    this.getFinalDocumentList();
    this.checkedFinalDocument = [];
  }

  submitSettings() {
    this.$store.commit("finalDocuments/CLEAR");
    this.getFinalDocumentList();
  }

  get iconClass() {
    return this.order === "DESC"
      ? "fas fa-long-arrow-alt-down"
      : "fas fa-long-arrow-alt-up";
  }

  sortDocuments(sortType: any) {
    if (this.sortedBy === sortType) {
      this.order = this.order === "DESC" ? "ASC" : "DESC";
    } else {
      this.order = "DESC";
    }
    this.sortedBy = sortType;
    this.$store.commit("finalDocuments/CLEAR");
    this.getFinalDocumentList();
  }

  getCategories() {
    if (this.selectedCompany) {
      api.CourseApi.categories(undefined, [this.selectedCompany]).then(
        (res: { data: IResourceCategory }) => {
          this.categoryList = res.data;
        }
      );
    } else {
      //@ts-ignore
      api.CourseApi.categories(this.userId, undefined).then(
        (res: { data: IResourceCategory }) => {
          this.categoryList = res.data;
        }
      );
    }
  }

  getDocTemplate() {
    api.DocumentTypeTaxonomyApi.list().then((res: { data: ITermList }) => {
      this.docTypeList = res.data.items;
    });
  }

  async getFinalDocumentList() {
    let params: FinalDocumentParams = {
      number: this.number,
      companyId: this.selectedCompany,
      issuedAtMin: this.issuedAtMin,
      issuedAtMax: this.issuedAtMax,
      isSignedAt: this.isSigned,
      sort: this.sortedBy,
      order: this.order,
      registerNumber: this.registerNumber,
      protocolsIds: this.protocol ? [this.protocol.id] : undefined,
      listenersIds: this.listenerId ? [this.listenerId] : undefined,
      categoryIds: this.categoryId ? [this.categoryId] : undefined,
      documentTypeIds: this.docTypeId ? [this.docTypeId] : undefined,
      isFisFrdoExported: this.isFisFrdoExported,
      fisFrdoType: this.fisFrdoType,
      fisFrdoExportedAtMin: this.fisFrdoExportedAtMin,
      fisFrdoExportedAtMax: this.fisFrdoExportedAtMax
    };
    this.isGettingResult = true;
    await this.$store.dispatch("finalDocuments/LIST", params);
    this.isGettingResult = false;
    this.checkAllDocuments = false;
  }

  unloadByQuery(type: 0 | 1) {
    this.isSpinnerLookAtHe = true;

    const params: IFirsFRDOParams = {
      type: type,
      number: this.number,
      companyId: this.selectedCompany,
      issuedAtMin: this.issuedAtMin,
      issuedAtMax: this.issuedAtMax,
      isSignedAt: this.isSigned,
      sort: this.sortedBy,
      order: this.order,
      protocolsIds: this.protocol ? [this.protocol.id] : undefined,
      listenersIds: this.listenerId ? [this.listenerId] : undefined,
      categoryIds: this.categoryId ? [this.categoryId] : undefined,
      documentTypeIds: this.docTypeId ? [this.docTypeId] : undefined,
      isFisFrdoExported: this.isFisFrdoExported,
      fisFrdoExportedAtMin: this.fisFrdoExportedAtMin,
      fisFrdoExportedAtMax: this.fisFrdoExportedAtMax,
      fisFrdoType: this.fisFrdoType,
      limit: parseInt(this.fisFRDOStep)
    };

    const formedFIRSFRdo = (params: IFirsFRDOParams) => {
      return api.FinalDocumentApi.unloadByFilter(
        params.type,
        params.number,
        params.documentTypeIds,
        params.categoryIds,
        params.companyId,
        params.ownerId,
        params.protocolsIds,
        params.coursesIds,
        params.listenersIds,
        params.status,
        params.documentOfRetraining,
        params.internship,
        params.graduateWork,
        params.numberDocumentOfRetraining,
        params.registerNumberDocumentOfRetraining,
        params.issuedAtMin,
        params.issuedAtMax,
        params.expirationMin,
        params.expirationMax,
        params.expirationNullable,
        params.isSignedAt,
        params.signedAtMin,
        params.signedAtMax,
        params.createdAtMin,
        params.createdAtMax,
        params.updatedAtMin,
        params.updatedAtMax,
        params.isArchive,
        params.archivedAtMin,
        params.archivedAtMax,
        params.isFisFrdoExported,
        params.fisFrdoExportedAtMin,
        params.fisFrdoExportedAtMax,
        params.fisFrdoType,
        params.offset,
        params.limit,
        params.sort,
        params.order,
        params.options
      );
    };

    formedFIRSFRdo(params)
      .then((res: { data: IFileItem }) => {
        this.file = res.data;
        if (res.data?.url) window.open(res.data.url, "_blank");
      })
      .finally(() => {
        this.isSpinnerLookAtHe = false;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  async unsetFIRSFRdo() {
    try {
      this.showSpinner = true;
      await api.FinalDocumentApi.resetUnloadFisFrdo(this.uniqueItems);
    } catch (e) {
      this.$bvToast.toast(
        `${this.$tc(this.$translate.SorrySomethingWentWrong)}`,
        {
          variant: "danger",
          title: `${this.$tc(this.$translate.Error)}`
        }
      );
    } finally {
      this.showSpinner = false;
      this.clearForm();
      this.modalShow = false;
    }
  }

  mounted() {
    this.getDocTemplate();
    this.getCategories();
    this.$store.commit("finalDocuments/CLEAR");
    this.getFinalDocumentList();
  }
}
